module.exports = __webpack_public_path__ + "static/media/product2.9ac8bb92.png";